import { render, staticRenderFns } from "./Choice.vue?vue&type=template&id=32e609e1&scoped=true&"
import script from "./Choice.vue?vue&type=script&lang=ts&"
export * from "./Choice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e609e1",
  null
  
)

export default component.exports